import * as TwcListActions from './list';
import * as TwcAddActions from './add';
import * as TwcListCategoriesActions from './listCategories';
import * as TwcVehicles from './vehicle';

const Actions = {
  ...TwcListActions,
  ...TwcAddActions,
  ...TwcListCategoriesActions,
  ...TwcVehicles,
};

export default Actions;
